import { render, staticRenderFns } from "./GetCouponsRelGood.vue?vue&type=template&id=6e7eae5f&"
import script from "./GetCouponsRelGood.vue?vue&type=script&lang=js&"
export * from "./GetCouponsRelGood.vue?vue&type=script&lang=js&"
import style0 from "./GetCouponsRelGood.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports